import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 36,
	viewBox: "0 0 28 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.2994 35.666C2.53551 35.666 1.88148 35.3941 1.33732 34.8502C0.793429 34.306 0.521484 33.652 0.521484 32.8881V15.2773C0.521484 14.5134 0.793429 13.8594 1.33732 13.3152C1.88148 12.7713 2.53551 12.4993 3.2994 12.4993H5.7994V8.72143C5.7994 6.49282 6.5851 4.5931 8.15648 3.02227C9.72787 1.45143 11.6283 0.666016 13.8577 0.666016C16.0872 0.666016 17.9866 1.45143 19.5561 3.02227C21.1255 4.5931 21.9102 6.49282 21.9102 8.72143V12.4993H24.4102C25.1741 12.4993 25.8282 12.7713 26.3723 13.3152C26.9162 13.8594 27.1882 14.5134 27.1882 15.2773V32.8881C27.1882 33.652 26.9162 34.306 26.3723 34.8502C25.8282 35.3941 25.1741 35.666 24.4102 35.666H3.2994ZM13.8594 27.3327C14.7544 27.3327 15.5191 27.0199 16.1536 26.3943C16.7877 25.7688 17.1048 25.0167 17.1048 24.1381C17.1048 23.277 16.7861 22.5109 16.1486 21.8398C15.5113 21.1684 14.7452 20.8327 13.8502 20.8327C12.9552 20.8327 12.1905 21.1684 11.5561 21.8398C10.9219 22.5109 10.6048 23.2817 10.6048 24.1523C10.6048 25.0225 10.9236 25.7702 11.5611 26.3952C12.1983 27.0202 12.9644 27.3327 13.8594 27.3327ZM8.5769 12.4993H19.1327V8.72143C19.1327 7.2556 18.62 6.00949 17.5944 4.9831C16.5686 3.95699 15.3232 3.44393 13.8582 3.44393C12.3929 3.44393 11.1463 3.95699 10.1186 4.9831C9.09079 6.00949 8.5769 7.2556 8.5769 8.72143V12.4993Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgLockIcon);
export default ForwardRef;
